import { linko } from "@shared/linko";
import type {
  StatisticsVolunteerInsightsQueryBody,
  StatisticsVolunteerInsightsResult,
} from "./types";

/**
 * Workaround: nested manifest typing doesn't expose `getVolunteerInsights`.
 * Runtime route exists; this wrapper centralizes the cast.
 */
type StatisticsQueriesVolunteerInsights = {
  getVolunteerInsights: (
    body: StatisticsVolunteerInsightsQueryBody,
  ) => Promise<{ data: StatisticsVolunteerInsightsResult }>;
};

export async function fetchStatisticsVolunteerInsights(
  body: StatisticsVolunteerInsightsQueryBody,
): Promise<StatisticsVolunteerInsightsResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesVolunteerInsights;
  const { data } = await queries.getVolunteerInsights(body);
  return data;
}

